export const REPORT_READY_STATUSES = new Set([
  "SCR_REPORT_GENERATED",
  "RR_SCHEDULED",
  "RR_RESCHEDULED",
  "RR_CANCELLED",
  "RR_IN_PROGRESS",
  "RR_COMPLETED",
]);

/** Screening complete; report not queued yet. */
export const REPORT_PENDING_STATUS = "SCR_YET_TO_GENERATE_REPORT";

/**
 * Some endpoints (e.g. the Needs Action dashboard) report this same
 * "screening done, report not generated yet" state under a different backend
 * value. Treat all known spellings as equivalent everywhere we gate on
 * "report pending", so status-naming drift between endpoints can't leave
 * stale appointment actions (Reschedule/Cancel) visible on the patient
 * details page.
 */
export const REPORT_PENDING_STATUSES = new Set([
  REPORT_PENDING_STATUS,
  "SCR_REPORT_PENDING",
]);

/** Report queued or actively generating. */
export const REPORT_GENERATING_STATUS = "SCR_GENERATING_REPORT";

export const REPORT_GENERATING_STATUSES = new Set([REPORT_GENERATING_STATUS]);

/** Poll while pending or generating until the report is ready. */
export const REPORT_POLLING_STATUSES = new Set([
  ...REPORT_PENDING_STATUSES,
  REPORT_GENERATING_STATUS,
]);

export const REPORT_FAILED_STATUS = "SCR_REPORT_GENERATION_FAILED";
